import {
  DELETE_REMINDER_INIT,
  DELETE_REMINDER_SUCCESS,
  DELETE_REMINDER_ERROR,
  DELETE_REMINDER_CLEAR,
} from '../../actions/reminder/constants';

const initState = {
  loading: false,
  data: null,
  error: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case DELETE_REMINDER_INIT:
      return { ...state, loading: true, error: null };
    case DELETE_REMINDER_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };
    case DELETE_REMINDER_ERROR:
      return { ...state, loading: false, error: action.payload };
    case DELETE_REMINDER_CLEAR:
      return { ...state, loading: false, data: null, error: null };
    default:
      return state;
  }
};
